import * as React from 'react';

import { NodeProps, Position } from '@xyflow/react';
import { Filter } from 'lucide-react';

import { BaseNode } from '../../BaseNode';
import type { FlowNode, NodeVisualDefinition } from '../../types';

import { FilterConfigType, getFilterPreviewText } from './schema';

/** Typed node for filter */
type FilterNodeType = FlowNode<FilterConfigType>;

/** Visual definition for the Filter node */
export const filterVisualDefinition: NodeVisualDefinition = {
  key: 'Filter',
  label: 'Filter',
  description: 'Continue flow only if condition is true',
  icon: Filter,
  color: 'teal',
  handles: [
    {
      type: 'target',
      position: Position.Top,
      className: 'bg-gray!',
    },
    {
      type: 'source',
      position: Position.Bottom,
      className: 'bg-gray!',
    },
  ],
  getContent: getFilterPreviewText as (
    config: Record<string, unknown>,
  ) => string,
};

/**
 * Visual component for Filter nodes on the canvas.
 * Uses BaseNode with single source handle - flow stops if condition is false.
 */
export const FilterNode = React.memo<NodeProps<FilterNodeType>>((props) => (
  <BaseNode
    {...props}
    definition={filterVisualDefinition}
    className="@FilterNode"
  />
));

FilterNode.displayName = 'FilterNode';
